import { ComponentProps } from '@/types/cms';
import classNames from 'classnames';
import { FC } from 'react';
import Size from '../../types/size';
import Mode from '../../types/display-mode';
import { twMerge } from 'tailwind-merge';

const Divider: FC<ComponentProps> = props => {
  const { properties } = props;

  return (
    <div
      role="separator"
      data-module={props.cmsComponentKey}
      style={{ borderColor: properties?.color }}
      className={twMerge(
        classNames('w-full h-0 mx-auto my-10 border-0', {
          'border-t': properties?.divider_height === Size.small,
          'border-t-[3px]': properties?.divider_height === Size.middle,
          'border-t-[7px]': properties?.divider_height === Size.large,
          'border-solid': properties?.display_mode === Mode.solid,
          'border-dotted': properties?.display_mode === Mode.dotted,
          'my-2.5': properties?.vertical_margin === Size.small,
          'my-5': properties?.vertical_margin === Size.middle,
          'my-10': properties?.vertical_margin === Size.large
        })
      )}
    />
  );
};

export default Divider;
